module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-element-profile"
  }, [_c('div', {
    ref: "c-masonry-grid",
    staticClass: "c-masonry-grid"
  }, [_c('div', {
    staticClass: "c-masonry-grid__sizer"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item c-masonry-grid__item--width-75"
  }, [_c('element-general-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item"
  }, [_c('element-atomic-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item"
  }, [(_vm.element.boilingPoint && _vm.element.boilingPoint['C'] && _vm.element.meltingPoint && _vm.element.meltingPoint['C']) ? _c('div', {
    staticClass: "card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title text-uppercase font-weight-bold"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("element.physicalProperties")))])]), _vm._v(" "), _c('bar-chart', {
    staticClass: "mt-5",
    attrs: {
      "element": _vm.element
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-masonry-grid__item c-masonry-grid__item--width-100"
  }, [_c('element-historical-properties', {
    attrs: {
      "element": _vm.element
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286b9e29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementProfile.vue
// module id = 637
// module chunks = 1